import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "key",
        headerName: "ID",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.05,
        flex: 1.5,
        filter: true,
    },
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.1,
        flex: 0.6,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 0.6,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.05,
        flex: 1,
        filter: true,
    },
    {
        field: "disAssembleQty",
        headerName: "DisAssemble qty",
        minWidth: window.innerWidth * 0.05,
        flex: 1,
        filter: true,
    },
    // {
    //     field: "rejection",
    //     headerName: "Rejection",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true,
    //     cellRenderer: 'agCheckboxCellRenderer',
    //     editable: true,
    // },
    // {
    //     field: "storeTransfer",
    //     headerName: "Store transfer",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true,
    //     cellRenderer: 'agCheckboxCellRenderer',
    //     editable: true,
    // },
    // {
    //     field: "rework",
    //     headerName: "Rework",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true,
    //     cellRenderer: 'agCheckboxCellRenderer',
    //     editable: true,
    // },
    // {
    //     field: "reworkComplete",
    //     headerName: "Rework complete",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true,
    //     cellRenderer: 'agCheckboxCellRenderer',
    //     editable: true,
    // },
    // {
    //     field: "completeDate",
    //     headerName: "Complete date",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true, 
    // },
    // {
    //     field: "rejectedPartChange",
    //     headerName: "Rejected part change",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true,
    //     cellRenderer: 'agCheckboxCellRenderer',
    //     editable: true,
    // },
    // {
    //     field: "changeDate",
    //     headerName: "Change date",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true,
    // },

];


export const DisAssembleTransactionPopup = (props) => {
    return (
        <ModalBasic
            id="disassemble-transaction"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Disassemble Transaction Details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>D_Ass. no</label>
                        <TextInput type='number'
                            id='dAssNo' name='dAssNo'
                            value={props.transactionObject.dAssNo}
                            handleChange={(event) => props.handleChange(event, 'dAssNo')}
                            className={props.validState?.error?.dAssNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.transactionObject.date}
                            handleChange={(event) => props.handleChange(event, 'date')}
                            className={props.validState?.error?.date !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>D-Assemble from</label>
                        <MultiSelectDropdown
                            drpIdentity="Select d-assemble"
                            options={props.transactionObject.dAssList}
                            value={props.transactionObject.idDAssFrom ? props.transactionObject.dAssList.find(x => x.value === props.transactionObject.idDAssFrom) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idDAssFrom")
                            }
                            className={props.validState?.error?.idDAssFrom !== undefined ? "error" : ""}
                        />

                    </div>
                    {/* <div className='input-grp col-span-2'>
                        <label>Challan no</label>
                        <MultiSelectDropdown
                            drpIdentity="Select challan"
                            options={props.transactionObject.challanNoList}
                            value={props.transactionObject.idChallanNo ? props.transactionObject.challanNoList.find(x => x.value === props.transactionObject.idChallanNo) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idChallanNo")
                            }
                            className={props.validState?.error?.idChallanNo !== undefined ? "error" : ""}
                        />

                    </div> */}
                    <div className='input-grp col-span-2'>
                        <label>Product</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select challan"
                            options={props.transactionObject.productList}
                            value={props.transactionObject.idProduct > 0 ? props.transactionObject.productList.find(x => x.value === props.transactionObject.idProduct) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idProduct")
                            }
                            className={props.validState?.error?.idProduct !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.transactionObject.itemIdLabel}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Stock Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.transactionObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>D-Quantity</label>
                        <TextInput type='number'
                            id='dQuantity' name='dQuantity'
                            value={props.transactionObject.dQuantity}
                            handleChange={(event) => props.handleChange(event, 'dQuantity')}
                            className={props.validState?.error?.dQuantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Ref. no</label>
                        <TextInput type='text'
                            id='refNo' name='refNo'
                            value={props.transactionObject.refNo}
                            handleChange={(event) => props.handleChange(event, 'refNo')}
                            className={props.validState?.error?.refNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Ref. date</label>
                        <TextInput type='date'
                            id='refDate' name='refDate'
                            value={props.transactionObject.refDate}
                            handleChange={(event) => props.handleChange(event, 'refDate')}
                            className={props.validState?.error?.refDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-1'>
                        <label>Plant</label>
                        <MultiSelectDropdown
                            drpIdentity="Select plant"
                            options={props.transactionObject.plantList}
                            value={props.transactionObject.idPlant > 0 ? props.transactionObject.plantList?.find(x => x.value === props.transactionObject.idPlant) : ""}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPlant")
                            }
                            className={props.validState?.error?.idPlant !== undefined ? "error" : ""}
                        />

                        {/* <MultiSelectDropdown
                            drpIdentity="Select d-assemble"
                            options={props.transactionObject.plantList}
                            value={props.transactionObject.idPlant ? props.transactionObject.plantList.find(x => x.value === props.transactionObject.idPlant) : ""}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPlant")
                            }
                            className={props.validState?.error?.idPlant !== undefined ? "error" : ""}
                        /> */}
                    </div>
                    <div className='input-grp !inline-flex !gap-[10px] mt-[30px]'>
                        <input type='CheckBox'
                            className='shadow-none w-[15px] h-[15px]'
                            id='assembly' name='assembly'
                            value={props.transactionObject.assembly}
                            checked={props.transactionObject.assembly}
                            onClick={(event) => props.handleChange(event, 'assembly')}
                        />
                        <label>Disassemble complete?</label>
                    </div>
                    <div className='input-grp'>
                        <label>Assembly date</label>
                        <TextInput type='date'
                            id='assemblyDate' name='assemblyDate'
                            value={props.transactionObject.assemblyDate}
                            handleChange={(event) => props.handleChange(event, 'assemblyDate')}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="save-btn btns" onClick={() => props.showBOMRecords()}>Show records</button>
                    </div>
                </div>
                <div className="process-table h-[35vh] mt-2.5">
                    <span className="text-blue text-[16px] font-semibold">Item details</span>
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.transactionObject.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-[35px]'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    {/* <button className="edit-btn btns">Preview rejection</button>
                    <button className="edit-btn btns">Store preview</button>
                    <button className="save-btn btns">Generate rework</button>
                    <button className="save-btn btns">Generate rejection</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}